module.exports = require("./uz-Latn.js");